/** Track-graph options and defaults for temporal convoy fork/merge (ENG-2580). */

import { CONVOY_PROXIMITY_RADIUS_METERS } from '../constants';

/** Hold last known position after a report for this long, then device is absent. */
export const CONVOY_TRACK_HOLD_MAX_SEC = 20 * 60;

/** Partition change must hold at least this long before we fork/merge. */
export const CONVOY_TRACK_MEMBERSHIP_MIN_SEC = 120;

/** Bump when graph semantics change so paint fingerprints invalidate. */
export const CONVOY_TRACK_GRAPH_OPTIONS_VERSION = 3;

export type BuildConvoyTrackGraphOptions = {
  radiusMeters?: number;
  holdMaxSec?: number;
  membershipMinSec?: number;
};

export function resolveTrackGraphOptions(
  partial: BuildConvoyTrackGraphOptions = {},
): Required<BuildConvoyTrackGraphOptions> {
  return {
    radiusMeters: partial.radiusMeters ?? CONVOY_PROXIMITY_RADIUS_METERS,
    holdMaxSec: partial.holdMaxSec ?? CONVOY_TRACK_HOLD_MAX_SEC,
    membershipMinSec:
      partial.membershipMinSec ?? CONVOY_TRACK_MEMBERSHIP_MIN_SEC,
  };
}
